export const arcosDoradosTheme = {
  colors: {
    primary: '#960048',
    secondary: '#ffbc0d',
    tomato: '#db001c',
    dark: '#2d2d2d',
    success: '#80bc00',
    warning: '#f18a00',
    brown: '#75391c',
    bordeaux: '#960048',
    purple: '#752157',
    teal: '#007078',
    cyan: '#1ecad3',
    gray: '#2d2d2d',
    darkGray: '#1f2829',
  },
  typography: {
    family: 'Speedee',
    weights: {
      light: 300,
      regular: 400,
      bold: 700,
    },
    fallback: ['Poppins', 'Nunito', 'Baloo', 'sans-serif'],
  },
} as const;
